import template from '../../mad-id.module.scss';
import { IListMad } from '../../mad-id.state'
import animations from '@styles/animations.module.scss'
import { InView } from 'react-intersection-observer';
import style from './project-info-section.module.scss'

interface IProjectInfoProps {
    title: string;
    list: Array<IListMad>;
}

const ProjectInfoSection = ({ title, list }: IProjectInfoProps) => {
    return (
        <section className={`${template.section}`}>
            <div className={`${template.container} ${template.flex} ${template.flex_spacebetween}`}>
                <InView triggerOnce={true}>
                    {({ inView, ref, entry }: any) => {
                        if (inView) {
                            entry.target.classList.add(animations.active);
                        }
                        return (
                            <div ref={ref} className={`${animations.scroll__animation} ${template.title} ${template.title_medium} ${template.margin_bot30px}`}>
                                {title}
                            </div>
                        )
                    }}
                </InView>
                <div className={`${template.flex} ${template.flex_column} ${style.project__content}`}>
                    {list.map((item: IListMad, index: number) => {
                        return (
                            <div className={`${template.margin_bot30px}`} key={index}>
                                <InView triggerOnce={true}>
                                    {({ inView, ref, entry }: any) => {
                                        if (inView) {
                                            entry.target.classList.add(animations.active);
                                        }
                                        return (
                                            <div ref={ref} className={`${animations.scroll__animation} ${template.title} ${template.title_small} ${template.margin_bot8px}`}>
                                                {item.title}
                                            </div>
                                        )
                                    }}
                                </InView>
                                <InView triggerOnce={true}>
                                    {({ inView, ref, entry }: any) => {
                                        if (inView) {
                                            entry.target.classList.add(animations.active);
                                        }
                                        return (
                                            <div ref={ref} className={`${animations.scroll__animation} ${template.text} ${template.text_medium}`}>
                                                {item.subtitle}
                                            </div>
                                        )
                                    }}
                                </InView>
                            </div>
                        )
                    })}
                </div>
            </div>
        </section>
    )
}

export default ProjectInfoSection;
